// import external dependencies
import Vue from "vue";
import { i18n } from "./i18n";
import VueCookies from "vue-cookies";
import vClickOutside from "v-click-outside";

Vue.use(VueCookies);
Vue.use(vClickOutside);

//vue event bus
import EventBus from "./event-bus.vue";
import GraphqlData from "./graphql-data.vue";
import { observeLazyIframes } from "./lazy-iframes";
import { initUtmAttribution } from "./utm-attribution";

import { ToggleList } from "./components/atomic/toggle-list.vue";
import { ToggleListV2 } from "./components/atomic/toggle-list-v2.vue";
import { ToggleListAbsolute } from "./components/atomic/toggle-list-absolute.vue";
import { ToggleListNewAbsolute } from "./components/atomic/toggle-list-new-absolute.vue";
import { LeadboxHeader } from "./components/leadbox-header.vue";
import { HoursFooter } from "./components/atomic/hours-footer.vue";
import { DealerHoursBlk } from "./components/atomic/dealer-hours-blk.vue";
import { SocialNetworks } from "./components/social-networks.vue";
import { ListWViewMore } from "./components/atomic/list-w-view-more.vue";
import { Dealertrack } from "./components/atomic/dealertrack.vue";
import { ToggleList3 } from "./components/atomic/toggle-list-3.vue";
import { ReadMore } from "./components/vdp/read-more.vue";
import { CountUp } from "./components/atomic/count-up.vue";

Vue.component("toggle-list", ToggleList);
Vue.component("toggle-list-v2", ToggleListV2);
Vue.component("toggle-list-absolute", ToggleListAbsolute);
Vue.component("toggle-list-new-absolute", ToggleListNewAbsolute);
Vue.component("leadbox-header", LeadboxHeader);
Vue.component("hours-footer", HoursFooter);
Vue.component("dealer-hours-blk", DealerHoursBlk);
Vue.component("social-networks", SocialNetworks);
Vue.component("list-w-view-more", ListWViewMore);
Vue.component("dealertrack", Dealertrack);
Vue.component("toggle-list-3", ToggleList3);
Vue.component("read-more", ReadMore);
Vue.component("count-up", CountUp);
//Vue.component('panorama', Panorama);

const addListener = EventTarget.prototype.addEventListener;
const paintFirst = !!document.querySelector(".vue-app[data-paint-first]");
const deferredReady = [];

if (paintFirst) {
  if (window.jQuery && jQuery.holdReady) {
    jQuery.holdReady(true);
  }

  document.addEventListener = function (type, listener, options) {
    if (type === "DOMContentLoaded") {
      deferredReady.push(listener);
      return;
    }

    return addListener.call(this, type, listener, options);
  };
}

function mountVueApps() {
  const vueAppContainerClass = ".vue-app";
  const vueAppContainers = document.querySelectorAll(vueAppContainerClass);

  Array.from(vueAppContainers).forEach((vueAppContainer) => {
    var styleEls = vueAppContainer.querySelectorAll("style");

    Array.from(styleEls).forEach((styleEl) => {
      styleEl.parentElement.removeChild(styleEl);
      document.head.appendChild(styleEl);
    });

    // Move script[type="text/template"] outside of Vue scope to prevent
    // Vue from trying to compile Underscore/Backbone templates (e.g., Ninja Forms Multi-Part)
    var templateScripts = vueAppContainer.querySelectorAll('script[type="text/template"]');
    Array.from(templateScripts).forEach((script) => {
      document.body.appendChild(script);
    });

    new Vue({
      el: vueAppContainer,
      i18n,
      methods: {
        closeAllOpenComponents() {
          EventBus.$emit("CLOSE_ALL_OPEN_COMPONENTS", null);
        },
      },
      events: {
        sendGAEvent: function (data) {
          console.log("sendGAEvent" + data);
        },
      },
    });
  });

  observeLazyIframes();
}

function releaseDeferredReady() {
  delete document.addEventListener;

  const event = new Event("DOMContentLoaded");
  deferredReady.splice(0).forEach((listener) => {
    try {
      if (typeof listener === "function") {
        listener.call(document, event);
      } else if (listener && listener.handleEvent) {
        listener.handleEvent(event);
      }
    } catch (error) {
      console.error(error);
    }
  });

  if (window.jQuery && jQuery.holdReady) {
    jQuery.holdReady(false);
  }
}

function afterHeroPaint(callback) {
  let done = false;
  const run = () => {
    if (!done) {
      done = true;
      callback();
    }
  };

  if (document.hidden) {
    run();
    return;
  }

  const paint = () => requestAnimationFrame(() => setTimeout(run, 0));
  const hero = document.querySelector(".lbx-slider__ssr-bg");

  setTimeout(run, 2500);

  if (!hero) {
    paint();
    return;
  }

  (hero.decode ? hero.decode() : Promise.reject()).then(paint, () => {
    if (hero.complete) {
      paint();
      return;
    }

    hero.addEventListener("load", paint, { once: true });
    hero.addEventListener("error", paint, { once: true });
  });
}

addListener.call(document, "DOMContentLoaded", () => {
  if (!paintFirst) {
    mountVueApps();
    document.dispatchEvent(new Event("lbx:vue-mounted"));
    return;
  }

  afterHeroPaint(() => {
    mountVueApps();
    releaseDeferredReady();
    document.dispatchEvent(new Event("lbx:vue-mounted"));
  });
});

initUtmAttribution();

window.Vue = Vue;
window.EventBus = EventBus;
window.GraphqlData = GraphqlData;
Vue.$cookies.config("30d");
Vue.config.devtools = process.env.NODE_ENV !== 'production';

import jQueryController from "./jQuery/Controller";
import Header from "./jQuery/Header";
import Footer from "./jQuery/Footer";

jQueryController.addComponents([Header, Footer]);
